// extracted by mini-css-extract-plugin
export default {"back":"back-button_back__RXKd+","link":"back-button_link__5pbnL"};